import type { ErrorInfo } from 'react';

import * as Sentry from '@sentry/browser';

/**
 * Simple Sentry error reporting utilities
 */

/**
 * Report React error boundary errors to Sentry
 */
export const reportErrorBoundaryError = (error: Error, errorInfo?: ErrorInfo) => {
  Sentry.captureException(error, {
    contexts: {
      react: {
        componentStack: errorInfo?.componentStack,
      },
    },
  });
};

/**
 * Report API errors to Sentry
 */
export const reportApiError = (
  error: Error,
  context?: {
    endpoint?: string;
    method?: string;
    statusCode?: number;
  }
) => {
  Sentry.captureException(error, {
    tags: {
      errorType: 'apiError',
      endpoint: context?.endpoint,
      method: context?.method,
      statusCode: context?.statusCode,
    },
  });
};

/**
 * Report general errors to Sentry
 */
export const reportError = (error: Error) => {
  Sentry.captureException(error);
};
